module.exports = __webpack_public_path__ + "img/realistic.63a7d4a4.svg";